// src/hooks/useCityQueryParam.js
import { useLocation } from "react-router-dom";

const useCityQueryParam = () => {
  const { search } = useLocation();
  const params = new URLSearchParams(search);
  return params.get("q")?.toLowerCase() || "ahmedabad";
};

export default useCityQueryParam;
